<template>
  <div class="bgc score">
    <Loading v-if="loading" />

    <div class="title">
      <div class="sort_son_title">
        {{ itemTitle }}
      </div>
      <div v-if="tableData && tableData.length">
        <a-button class="btn" type="primary" ghost @click="importTo">
          {{ $t('exam.downbtn') + itemTitle }}
        </a-button>
        <!-- <a-button class="btn" type="primary" ghost @click="importZip">
          <a-icon type="file-zip" />
          导出zip
        </a-button> -->
      </div>
    </div>

    <div class="table_div">
      <Table
        :columns="columns"
        :pagination="pagination"
        :data="tableData"
        @change="tableChange"
      />
      <!-- <div v-if="withoutPage.total > realSize" class="page-box">
        <a-pagination
          v-model="withoutPage.pageIndex"
          show-quick-jumper
          :hide-on-single-page="true"
          :default-page-size="realSize"
          :total="withoutPage.total"
          @change="onChange"
        />
      </div> -->
    </div>
  </div>
</template>

<script>
  import axios, { getCookie } from '@utils'
  import ApiXy from '@lib/api.js'
  import Table from '@comp/tables/sortTable.vue'
  import Loading from '@comp/loading'
  import { getCol } from '@utils/unite.js'
  import i18n from '@/lang/index'

  const columns1 = getCol('subtopicScoreUnion') || [
    {
      title: i18n.t('exam.scoreTableColum[0]'),
      dataIndex: 'classType',
      key: 'classType',
      width: 100,
      ellipsis: true
    },
    {
      title: i18n.t('exam.scoreTableColum[1]'),
      dataIndex: 'className',
      key: 'className',
      width: 160,
      ellipsis: true
    },
    {
      title: i18n.t('exam.scoreTableColum[2]'),
      dataIndex: 'name',
      key: 'name',
      width: 100,
      ellipsis: true
    },
    {
      title: i18n.t('exam.scoreTableColum[3]'),
      dataIndex: 'score',
      key: 'score',
      width: 80
    },
    {
      title: i18n.t('exam.scoreTableColum[4]'),
      dataIndex: 'essClassOrder',
      key: 'essClassOrder',
      hideRank: true,
      width: 100
    },
    {
      title: i18n.t('exam.scoreTableColum[5]'),
      dataIndex: 'essGradeOrder',
      key: 'essGradeOrder',
      hideRank: true,
      width: 100
    },
    {
      title: i18n.t('exam.scoreTableColum[6]'),
      dataIndex: 'objectScore',
      key: 'objectScore',
      width: 80
    },
    {
      title: i18n.t('exam.scoreTableColum[7]'),
      dataIndex: 'subjectScore',
      key: 'subjectScore',
      width: 80
    }
  ]
  export default {
    name: 'Stuansquenum',
    components: {
      Table,
      Loading
    },
    props: {
      itemTitle: {
        type: String,
        default: ''
      },
      hideRank: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        loading: false,
        columns: [],
        columns1,
        tableData: [],
        pagination: {
          // hideOnSinglePage: true, //total无则一页故隐藏table分页
          // pageSize: 10, //table条数(最小粒度呈现)
          // total: 10 //total需<=于pageSize
          pageSize: 10,
          total: 0,
          showQuickJumper: true,
          showSizeChanger: true,
          hideOnSinglePage: true,
          pageSizeOptions: ['10', '20', '100', '200', '500']
        },
        // pageSize: 5, //请求条数(题号分页条数)
        // withoutPage: {
        //   pageIndex: 1,
        //   pageSize: 10,
        //   total: 0
        // },
        orderField: 'eqDisplayIndex',
        orderType: 'ascend'

        // realSize: 10 //data一页长度(为解决传入数和返回数据数不一致)
      }
    },
    watch: {
      $route: {
        handler() {
          if (this.$route.query.classId || this.$route.query.seId) {
            this.getTable(1)
          }
        },
        deep: true
      }
    },
    mounted() {
      this.getTable(1)
    },
    methods: {
      // customRow(record) {
      //   let className =
      //     this.$route.query.classId * 1 &&
      //     record.classId == this.$route.query.classId
      //       ? 'current'
      //       : ''
      //   return className
      // },
      // 表格排序
      tableChange(pagination, a, sort) {
        let { field, order } = sort
        if (order) {
          this.orderField = field
          this.orderType = order
        } else {
          this.orderField = ''
          this.orderType = ''
        }

        this.pagination = { ...pagination }
        this.getTable(pagination.current)
      },
      // 表格分页
      onChange(pagination) {
        this.getTable(pagination.current)
      },
      //数据封装过滤
      dataFilter(data) {
        //copy data避免污染
        data = JSON.parse(JSON.stringify(data))
        let datas = []
        data.forEach(item => {
          let childData = JSON.parse(
            JSON.stringify(item.questionStudentDetailVos)
          )
          delete item.questionStudentDetailVos
          if (childData && childData.length) {
            childData = childData.filter(
              item => item.errorStudentDetail != '无'
            )
            childData.forEach((itemc, indexc) => {
              let dataItem = {
                ...item,
                ...itemc,
                rowSpan: !indexc ? childData.length : 0
              }
              datas.push(dataItem)
            })
          } else {
            datas.push(item)
          }
        })
        return datas
      },

      // getstudentscoredetaillist
      //获取table数据  // 学生答题明细---新
      getTable(pageIndex) {
        this.loading = true
        let {
          dId: groupId,
          classId,
          seId,
          meId,
          examIsActive = 1,
          campusId
        } = this.$route.query
        let params = {
          meId,
          seId,
          groupId,
          pageSize: this.pagination.pageSize,
          pageIndex,
          classId,
          orderField: this.orderField,
          orderType: this.orderType.replace('end', ''),
          campusId
        }
        let unionUrl = [
          'subtopicScore',
          'subtopicScoreUnion',
          'subtopicScoreUnion'
        ]
        let url = unionUrl[examIsActive]
        axios({
          url,
          params,
          loading: false
        })
          .then(res => {
            this.loading = false
            let pageObj = {}
            if (res.status) {
              this.columns = []
              // this.realSize = res.data.length
              pageObj = {
                current: pageIndex,
                total: res.total
              }

              let columns2 = []
              let columns3 = []
              // 校考，添加卷型
              if (examIsActive == 0) {
                let list = res.paperGroupTitles || []
                list.forEach((item, index) => {
                  columns3.push({
                    title: item,
                    dataIndex: 'group' + index,
                    key: 'group' + index,
                    align: 'center',
                    width: 100
                  })
                })
              }
              this.titles = res.questionlist.map(item => item.name)
              // 修改表格头部
              this.titles.forEach((item, index) => {
                columns2.push({
                  title: item,
                  children: [
                    {
                      title: res.questionlist[index].score,
                      dataIndex: 'score' + index,
                      key: 'score' + index,
                      align: 'center',
                      width: 100
                    }
                  ]
                })
              })
              if (this.hideRank) {
                this.columns1 = this.columns1.filter(item => !item.hideRank)
              }
              this.columns = [...this.columns1, ...columns3, ...columns2]

              // 修改表格数据结构
              let tableData = res.data
              tableData.forEach(item => {
                item.scoreList.forEach((col, i) => {
                  item['score' + i] = col.score
                })
                let arr = item.paperGroupScores || []
                arr.forEach((ele, i) => {
                  item['group' + i] = ele
                })
              })
              this.tableData = tableData
            } else {
              this.tableData = []
              pageObj = {
                current: 1,
                total: 0
              }
            }
            this.pagination = {
              ...this.pagination,
              ...pageObj
            }
          })
          .catch(() => {
            setTimeout(() => {
              this.loading = false
            }, 200)
          })
      },

      // 下载
      importTo() {
        let {
          seId,
          meId,
          classId,
          dId: groupId,
          examIsActive = 1,
          campusId
        } = this.$route.query
        let unionUrl = [
          'exportquestionprintsingle',
          'exportquestionprintsingleUnion',
          'exportquestionprintsingleUnion'
        ]
        let union = unionUrl[examIsActive]
        let api = ApiXy.defaulteApi.path[union]
        let url =
          `${ApiXy.defaulteApi.host}${api}` +
          `?campusId=${campusId}&seId=${seId}&meId=${meId}&classId=${classId}&groupId=${groupId}&orderField =${
            this.orderField
          }&orderType=${this.orderType.replace('end', '')}&X-ZYLX-TOKEN=${getCookie(
            'X-ZYLX-TOKEN'
          )}`
        window.open(url, '_blank', '')
      }
      // importZip() {
      //   let url =
      //     `${ApiXy.defaulteApi.host}` +
      //     `${ApiXy.defaulteApi.path.studentscoredetaillistzip}` +
      //     `?userId=${this.$store.state.userInfo.userId}` +
      //     `&authId=${this.$route.query.authId}` +
      //     `&seId=${this.$route.query.seId}` +
      //     `&classId=${this.$route.query.classId}` +
      //     `&apiorderField=${this.orderField}` +
      //     `&orderType=${this.orderType.replace('end', '')}` +
      //     '&X-ZYLX-TOKEN=' +
      //     getCookie('X-ZYLX-TOKEN')
      //   window.open(url, '_blank', '')
      // }
    }
  }
</script>
<style lang="less" scoped>
  // /deep/.current {
  //   background: rgba(60, 100, 239, 0.2);
  //   td {
  //     background: none !important;
  //   }
  // }
  .score {
    height: 100%;
    background: #fff;
    .left {
      float: left;
    }
    .right {
      float: right;
    }
    .title {
      // height: 58px;
      // line-height: 58px;
      // font-size: 16px;
      // color: rgba(0, 0, 0, 0.85);
      // margin-top: -50px;
      .left_div {
        margin-left: 24px;
      }
      .right_div {
        margin-right: 24px;
        .btn {
          margin-left: 12px;
        }
      }
    }
    .table_div {
      height: calc(100% - 58px);
      padding: 0 20px;
      /deep/ .ant-table-body {
        border-top: 1px solid #e8e8e8;
        border-bottom: 1px solid #e8e8e8;
        // max-height: 55vh;
        overflow-y: auto;
        &:hover::-webkit-scrollbar-thumb {
          visibility: visible;
        }
      }
      /deep/ .ant-table-body {
        table {
          border-top: 0;
        }
      }
    }
  }
  .page-box {
    padding: 30px 10px 10px;
    text-align: center;
  }
</style>
